"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var EventInit = require("../generated/EventInit");

var EventImpl = /*#__PURE__*/function () {
  function EventImpl(args, privateData) {
    _classCallCheck(this, EventImpl);

    var type = args[0]; // TODO: Replace with destructuring

    var eventInitDict = args[1] || EventInit.convert(undefined);
    this.type = type;
    var wrapper = privateData.wrapper;

    for (var key in eventInitDict) {
      if (key in wrapper) {
        this[key] = eventInitDict[key];
      }
    }

    this.target = null;
    this.currentTarget = null;
    this.eventPhase = 0;
    this._initializedFlag = true;
    this._stopPropagationFlag = false;
    this._stopImmediatePropagationFlag = false;
    this._canceledFlag = false;
    this._dispatchFlag = false;
    this.isTrusted = privateData.isTrusted || false;
    this.timeStamp = Date.now();
  }

  _createClass(EventImpl, [{
    key: "stopPropagation",
    value: function stopPropagation() {
      this._stopPropagationFlag = true;
    }
  }, {
    key: "stopImmediatePropagation",
    value: function stopImmediatePropagation() {
      this._stopPropagationFlag = true;
      this._stopImmediatePropagationFlag = true;
    }
  }, {
    key: "preventDefault",
    value: function preventDefault() {
      if (this.cancelable) {
        this._canceledFlag = true;
      }
    }
  }, {
    key: "_initialize",
    value: function _initialize(type, bubbles, cancelable) {
      this.type = type;
      this._initializedFlag = true;
      this._stopPropagationFlag = false;
      this._stopImmediatePropagationFlag = false;
      this._canceledFlag = false;
      this.isTrusted = false;
      this.target = null;
      this.bubbles = bubbles;
      this.cancelable = cancelable;
    }
  }, {
    key: "initEvent",
    value: function initEvent(type, bubbles, cancelable) {
      if (this._dispatchFlag) {
        return;
      }

      this._initialize(type, bubbles, cancelable);
    }
  }, {
    key: "defaultPrevented",
    get: function get() {
      return this._canceledFlag;
    }
  }, {
    key: "cancelBubble",
    get: function get() {
      return this._stopPropagationFlag;
    },
    set: function set(v) {
      if (v) {
        this._stopPropagationFlag = true;
      }
    }
  }]);

  return EventImpl;
}();

module.exports = {
  implementation: EventImpl
};